import { TextField } from '@backstage/ui';

interface DescriptionInputProps {
  entityKind: string;
  description: string;
  setDescription: (name: string) => void;
}

export const DescriptionInput = (props: DescriptionInputProps) => {
  const { entityKind, description, setDescription } = props;

  return (
    <TextField
      name={`${entityKind.toLowerCase()}Description`}
      label={`${entityKind} Description`}
      type="text"
      value={description}
      onChange={value => setDescription(value)}
    />
  );
};
